<template>
  <div class="row" v-if="show">
    <div class="col-md-12 mb-2">
      <div class="collapseFormItem">
        <div class="title">
          <div class="row">
            <div class="col-md-8">{{section.label}}</div>
            <div class="col-md-4 text-right">
              <p>
                <span
                  class="clickable"
                  data-toggle="collapse"
                  :data-target="'#' + section.name + '_gui_body'"
                >
                  <icon name="chevron-up" class="chevron-up" />
                  <icon name="chevron-down" class="chevron-down" />
                </span>
              </p>
            </div>
          </div>
        </div>

        <div :id="section.name + '_gui_body'" class="collapseBody collapse show">
          <row-component :section="section" :key="section.name" :gridId="gridId" :rowData="rowData"></row-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import RowComponent from '@/components/DataGrid/FormBuilder/gui/ui/RowComponent'
import { Hooks } from '@/components/DataGrid/FormBuilder/gui/components/hook_lists'

export default {
  name: 'CollapseSectionLayout',
  components: { RowComponent },
  props: ['section', 'gridId', 'rowData'],
  computed: {
    ...mapState(['fbUserModels', 'models_dashboardModel']),
    show() {
      const rowData = this.rowData

      if (!this.$props.section.vif) return true

      return eval(this.$props.section.vif)
    },
  },
  created() {
    // before hook
    Hooks.Section.beforeRegister.run(this.section)
  },
  mounted() {
    // after hook
    Hooks.Section.afterRegister.run(this.section)
  },
}
</script>

<style scoped>
.clickable {
  cursor: pointer;
}

.collapseFormItem .title {
  font-weight: bold;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.collapseFormItem .collapsed .chevron-up,
.collapseFormItem .chevron-down {
  display: none;
}

.collapseFormItem .collapsed .chevron-down,
.collapseFormItem .chevron-up {
  display: inline-block;
}
</style>
